// extracted by mini-css-extract-plugin
export default {"logout":"QFQp8X4O4mfISgd634Ut"};